import React, { createContext, ReactNode, useContext } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { NewCustomerSchema, newCustomerSchema } from "../schemas/customers";
import { useForm, UseFormReturn } from "react-hook-form";

// useForm cannot live in a Zustand store, so it stays in React context.
// All other transaction state lives in useCartStore / useTransaksiUIStore.
const TransaksiFormContext = createContext<
    UseFormReturn<NewCustomerSchema> | undefined
>(undefined);

interface ITransaksiContext {
    children: ReactNode;
}

const TransaksiProvider = ({ children }: ITransaksiContext) => {
    const newCustomerForm = useForm<NewCustomerSchema>({
        resolver: yupResolver(newCustomerSchema),
        mode: "onChange",
    });

    return (
        <TransaksiFormContext.Provider value={newCustomerForm}>
            {children}
        </TransaksiFormContext.Provider>
    );
};

const useTransaksiForm = (): UseFormReturn<NewCustomerSchema> => {
    const ctx = useContext(TransaksiFormContext);
    if (ctx === undefined) {
        throw new Error(
            "useTransaksiForm must be used within a TransaksiProvider",
        );
    }
    return ctx;
};

// Keep TransaksiContext export so any direct context reads still compile.
const TransaksiContext = TransaksiFormContext;

export { TransaksiContext, TransaksiProvider, useTransaksiForm };
